import API from "../api";
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// 🟢 NEW: Haptic Feedback Engine
const vibrate = (pattern) => {
  if (typeof window !== "undefined" && navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};

function Signup() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState(""); // 🆕 Added Email State
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    // 🚨 Updated Validation to include Email
    if (!name || !phone || !email || !password || !confirmPassword) {
      vibrate([100, 50, 100]); // 📳 Error double-vibrate
      alert("All fields are required");
      return;
    }

    // 🚨 NEW VALIDATION: Must be exactly 10 digits
    if (phone.length !== 10) {
      vibrate([100, 50, 100]); // 📳 Error double-vibrate
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    if (password !== confirmPassword) {
      vibrate([100, 50, 100]); // 📳 Error double-vibrate
      alert("Passwords do not match");
      return;
    }

    try {
       await API.post("/auth/register", {
        name,
        phone,
        email, // 🆕 Sending Email to Backend
        password
      });

      vibrate([50, 50, 50]); // 📳 Success burst!
      alert("Signup successful. Please login.");
      navigate("/login");

    } catch (err) {
      console.error(err);
      vibrate([100, 50, 100]); // 📳 Error double-vibrate
      alert(err.response?.data?.message || "Signup failed");
    }
  };

  return (
    <div style={pageContainer}>
      <div style={authCard}>
        
        <div style={iconCircle}>✨</div>
        <h2 style={titleStyle}>Create Account</h2>
        <p style={subtitleStyle}>Join Delight Store for faster checkouts.</p>

        <form onSubmit={handleSignup}>
          
          <label style={labelStyle}>Full Name</label>
          <input
            placeholder="e.g. Rahul Sharma"
            value={name}
            onChange={e => setName(e.target.value)}
            style={inputStyle}
          />

          <label style={labelStyle}>Phone Number</label>
          <input
            type="tel"
            placeholder="10-digit mobile number"
            value={phone}
            maxLength="10" 
            onChange={e => setPhone(e.target.value.replace(/\D/g, ""))}
            style={inputStyle}
          />

          {/* 🆕 NEW EMAIL INPUT FIELD */}
          <label style={labelStyle}>Email Address</label>
          <input
            type="email"
            placeholder="e.g. rahul@example.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={inputStyle}
            required
          />

          <label style={labelStyle}>Password</label>
          <input
            type="password"
            placeholder="Choose a strong password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={inputStyle}
          />

          <label style={labelStyle}>Confirm Password</label>
          <input
            type="password"
            placeholder="Type your password again"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            style={inputStyle}
          />

          <button type="submit" style={submitBtn}>
            Sign Up
          </button>
        </form>

        <div style={footerText}>
          Already have an account? <Link to="/login" onClick={() => vibrate(20)} style={linkStyle}>Log in here</Link>
        </div>

      </div>
    </div>
  );
}

// ================= THEMATIC STYLES =================
const pageContainer = { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "85vh", padding: "20px", background: "#FAFAFA", fontFamily: "'Segoe UI', Roboto, sans-serif" };
const authCard = { background: "#FFF", width: "100%", maxWidth: "400px", padding: "40px 30px", borderRadius: "16px", boxShadow: "0 10px 30px rgba(0,0,0,0.06)", border: "1px solid #E0E0E0" };
const iconCircle = { width: "60px", height: "60px", background: "#FFF3E0", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto 15px auto", fontSize: "28px" };
const titleStyle = { color: "#333", fontSize: "26px", textAlign: "center", margin: "0 0 5px 0" };
const subtitleStyle = { color: "#666", fontSize: "14px", textAlign: "center", marginBottom: "20px" };
const labelStyle = { display: "block", fontSize: "13px", fontWeight: "600", color: "#555", marginBottom: "6px", marginTop: "15px" };
const inputStyle = { width: "100%", padding: "12px 15px", borderRadius: "8px", border: "1px solid #CCC", background: "#FAFAFA", outline: "none", boxSizing: "border-box", fontSize: "15px", transition: "0.3s" };
const submitBtn = { width: "100%", padding: "14px", marginTop: "25px", background: "#F57C00", color: "#FFF", border: "none", borderRadius: "8px", fontSize: "16px", fontWeight: "bold", cursor: "pointer", boxShadow: "0 4px 12px rgba(245, 124, 0, 0.25)" };
const footerText = { textAlign: "center", marginTop: "25px", fontSize: "14px", color: "#666", borderTop: "1px solid #eee", paddingTop: "20px" };
const linkStyle = { color: "#2E7D32", fontWeight: "bold", textDecoration: "none" };

export default Signup;